import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { InstructionComponentModel } from '@libs/common/models';

@Component({
  selector: 'ui-instruction',
  templateUrl: './instruction.component.html',
  styleUrls: ['./instruction.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InstructionComponent {
  @Input() public model: InstructionComponentModel = [];
}
